export default __webpack_public_path__ + "img/1f1fd6c91efcf0ea69392925fd32e910.png";